var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 182749"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 228",
    d: "m15.648 45.269-8.31-14.387h3.949l6.335 10.964h22.186l6.331-10.964h3.949l-8.305 14.387zm5.441-9.275-6.726-11.648H6.638l2.089 2.089 2 2H5.8l-5.8-5.8 5.792-5.8h4.929l-2 2-2.093 2.088h7.725l6.725-11.648H36.5l6.726 11.649h7.618l-4.093-4.091h4.939l5.8 5.8-5.8 5.8h-4.927l4.093-4.091h-7.617l-6.726 11.652zm-3.764-13.363 5.734 9.937h11.473l5.735-9.937-5.735-9.94H23.059zm29.428-8.244h-.614L39.808 3.423H17.622l-6.335 10.964H7.338L15.648 0h26.135l8.305 14.387z",
    transform: "translate(3.047 9.143)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon3);
export default __webpack_public_path__ + "static/media/features-icon-3.460acfc3d5c72326fcaad9939cde8235.svg";
export { ForwardRef as ReactComponent };